import React, { FC, forwardRef } from 'react';
import { LangSelect } from '../lang-select/lang-select';
import { LangEnum, LangType } from '../../helpers/lang';
import { useInputLangStore } from '../../store/use-input-lang-store';
import { TextArea, TextAreaProps } from '../../components/textarea/textarea';
import s from './lang-textarea.module.css';

export interface LangTextAreaProps extends Omit<TextAreaProps, 'value' | 'onChange'> {
  onChange: (value: LangType) => void;
  value?: LangType;
  showLanguageSelect?: boolean;
}

export const LangTextArea: FC<LangTextAreaProps> = forwardRef<
  HTMLTextAreaElement,
  LangTextAreaProps
>((props, ref) => {
  const { onChange, value, showLanguageSelect = false, ...other } = props;

  const { language } = useInputLangStore();

  const handleChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const val = e.currentTarget.value;
    onChange({ ...value, [language as LangEnum]: val });
  };

  return (
    <div className={s.feature}>
      <TextArea
        className={s.textarea}
        onChange={handleChange}
        value={value?.[language as LangEnum]}
        ref={ref}
        {...other}
      />
      {showLanguageSelect && <LangSelect className={s.select} disabled={props.disabled} />}
    </div>
  );
});
